import { AxiosResponse } from "axios";
import { ApiResponse } from "../types/api.types";
import { BlockedIp, BlockedIpFilters, BlockedIpPageResponse, UnblockIpRequest } from "../types/blockedIp";
import api from "./api";

const BASE_URL = "/ip-block";

export const getBlockedIps = async (
  page = 0,
  size = 10,
  filters?: BlockedIpFilters
): Promise<AxiosResponse<ApiResponse<BlockedIpPageResponse>>> => {
  const request = {
    pageNumber: page,
    pageSize: size,
    filter: filters || {},
  };
  return api.post(`${BASE_URL}/list`, request);
};

export const unblockIp = async (
  ipAddress: string
): Promise<AxiosResponse<ApiResponse<string>>> => {
  const request: UnblockIpRequest = {
    id: ipAddress,
  };
  return api.post(`${BASE_URL}/unblock`, request);
};